import React, { useState } from "react";
import {
  Modal,
  Form,
  Input,
  Upload,
  Button,
  Alert,
  Typography,
  message,
} from "antd";
import {
  UploadOutlined,
  CloudUploadOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import axiosInstance from "../../configs";

const { Text } = Typography;

const ModalUploadFile = ({ visible, onClose }) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleFileChange = ({ fileList }) => {
    const isExcel =
      fileList.length > 0 &&
      fileList[0].type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    if (!isExcel && fileList.length > 0) {
      setErrorMsg("Hanya file Excel (.xlsx) yang diperbolehkan!");
      setFileList([]);
    } else {
      setErrorMsg("");
      setFileList(fileList);
    }
  };

  const handleUpload = async () => {
    try {
      await form.validateFields();
      const npwp = "063239834304400";
      const file = fileList[0]?.originFileObj;

      if (!file) {
        setErrorMsg("Silakan pilih file Excel terlebih dahulu!");
        return;
      }

      setLoading(true);
      setErrorMsg("");

      const formData = new FormData();
      formData.append("file", file);

      const response = await axiosInstance.post(
        `/portal/pasifik/post-file/${npwp}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const result = response.data;
      console.log("Upload berhasil:", result);

      message.success("Dokumen berhasil diunggah!");
      setFileList([]);
      form.resetFields();
      onClose();
      setInterval(() => {
        window.location.reload();
      }, 1200);
    } catch (error) {
      console.error(error);
      setErrorMsg(error.message || "Terjadi kesalahan saat mengunggah file.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form form={form} layout="vertical" className="kt-form">
      {/* <Form.Item
        label={<Text strong>NPWP</Text>}
        name="npwp"
        rules={[{ required: true, message: "NPWP wajib diisi!" }]}
      >
        <Input placeholder="Masukkan NPWP" maxLength={15} />
      </Form.Item> */}

      <Form.Item
        label={<Text strong>File Excel</Text>}
        required
        validateStatus={errorMsg ? "error" : ""}
      >
        <Upload
          beforeUpload={() => false} // Mencegah auto-upload
          fileList={fileList}
          onChange={handleFileChange}
          accept=".xlsx"
          maxCount={1}
        >
          <Button icon={<UploadOutlined />}>Pilih File Excel</Button>
        </Upload>
        {fileList.length > 0 && (
          <Text type="secondary" style={{ display: "block", marginTop: 8 }}>
            File terpilih: {fileList[0].name}
          </Text>
        )}
      </Form.Item>

      <div style={{ textAlign: "right", marginTop: 24 }}>
        <Button
          icon={<CloseOutlined />}
          style={{ marginRight: 8 }}
          onClick={onClose}
        >
          Batal
        </Button>
        <Button
          type="primary"
          icon={<CloudUploadOutlined />}
          loading={loading}
          onClick={handleUpload}
        >
          {loading ? "Mengunggah..." : "Unggah"}
        </Button>
      </div>
    </Form>
  );
};

export default ModalUploadFile;
